import { render, staticRenderFns } from "./ObjectTable.vue?vue&type=template&id=671b56ec&scoped=true"
import script from "./ObjectTable.vue?vue&type=script&lang=js"
export * from "./ObjectTable.vue?vue&type=script&lang=js"
import style0 from "./ObjectTable.vue?vue&type=style&index=0&id=671b56ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b56ec",
  null
  
)

export default component.exports